import { createAsyncThunk } from '@reduxjs/toolkit';

export const setSignature = createAsyncThunk(
  'setSignature',
  async (
    data: { signature: string },
    { dispatch, extra, getState }: { dispatch: any; extra: any; getState: any }
  ) => {
    return {
      signature: data.signature,
    };
  }
);

export default setSignature;
